import React from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons';

const SkeletonContainer = styled.article`
  svg {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -40px;
    margin-top: -40px;
  }
`;

export const SkeletonMain = () => (
  <SkeletonContainer>
    <FontAwesomeIcon color="var(--primary-color)" icon={faSpinner} size="5x" spin />
  </SkeletonContainer>
);

const SkeletonSectionContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 2rem;
  background: ${props => props.backgroundColor || 'rgba(0, 0, 0, 0.2)'};
  z-index: var(--zindexBig);
`;

const StyledCenteredIcon = styled(FontAwesomeIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
`;

export const SkeletonSection = ({ ...props }) => (
  <SkeletonSectionContainer {...props}>
    <StyledCenteredIcon color="var(--primary-color)" icon={faSpinner} size="3x" spin />
  </SkeletonSectionContainer>
);
